import React, { FC } from "react";
import useKontentServiceApi from "../services/useKontentServiceApi";
import { kontentVariables } from "../utils";

const CoreValues: FC = () => {
  const { data } = useKontentServiceApi(
    kontentVariables.ourcorevaluesContentType
  );
  return (
    <section
      id="make_us"
      className="make-us-sec smt-8 company-standards mt-sd-1 mt-med-1 mt-ld-4"
    >
      <div className="container">
        <div className="row gy-4">
          <div className="col-lg-6 make-us-haed">
            <div className="section-header">
              <h3>
                {data?.elements?.our_core_values?.value.replace(
                  /(<([^>]+)>)/gi,
                  ""
                )}
              </h3>
            </div>
          </div>
          <div className="col-lg-1 md-hidden make-us-haed"></div>
          <div className="col-lg-5 mt-lg-4 mt-med-0">
            <div className="make-us-content">
              <p>
                {data?.elements?.we_lead?.value.replace(/(<([^>]+)>)/gi, "")}
              </p>
            </div>
          </div>
        </div>
        <div className="row mt-3 mt-med-0 gy-4">
          <div className="col-lg-4 col-md-6 make-us-card">
            <img loading="lazy"
              src={data?.elements?.block_img1?.value[0]?.url}
              className="img-fluid"
              alt="Empathy"
            />
            <h4>
              {data?.elements?.empathy?.value.replace(/(<([^>]+)>)/gi, "")}
            </h4>
            <p>
              {data?.elements?.we_deeply?.value.replace(/(<([^>]+)>)/gi, "")}
            </p>
          </div>
          <div className="col-lg-4 col-md-6 make-us-card">
            <img loading="lazy"
              src={data?.elements?.block_img2?.value[0]?.url}
              className="img-fluid"
              alt="Deliver Results"
            />
            <h4>
              {data?.elements?.deliver_results?.value.replace(
                /(<([^>]+)>)/gi,
                ""
              )}
            </h4>
            <p>
              {data?.elements?.we_prioritize?.value.replace(
                /(<([^>]+)>)/gi,
                ""
              )}
            </p>
          </div>
          <div className="col-lg-4 col-md-6 make-us-card">
            <img loading="lazy"
              src={data?.elements?.block_img3?.value[0]?.url}
              className="img-fluid"
              alt="One of Us"
            />
            <h4>
              {data?.elements?.one_of_us?.value.replace(/(<([^>]+)>)/gi, "")}
            </h4>
            <p>
              {data?.elements?.we_build?.value.replace(/(<([^>]+)>)/gi, "")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoreValues;
